<template>
    <div id="option-input-container" class="col-12"
    >
        <div class='d-flex flex-nowrap'>
            <div class="col-1">
                <FormElementWithoutLabel
                    :error="error.is_correct"
                >
                    <div class="mt-2 abc-checkbox abc-checkbox-circle abc-checkbox-success">
                        <input
                            name="is_correct_answer"
                            :id="`is_correct_answer_${compositeId}`"
                            type="checkbox"
                            v-model="option.is_correct"
                            :checked="option.is_correct">
                        <label :for="`is_correct_answer_${compositeId}`" class="pl-20 pt-10"></label>
                    </div>
                </FormElementWithoutLabel>
            </div>

            <div :ref="`mcq_option_${compositeId}`"
                 class="col-10"
                 @click="makeEditable('option' + compositeId, index)">
                <div v-if="currentlyEditingItemIndex===index && currentlyEditingItemType==='option' + compositeId">
                    <SummerNote
                        :index='compositeId'
                        for-type="answer"
                        :on-change="onChange"
                        :on-change-content="onChangeContent"
                        :content="option.body"
                        :error="error.body"
                        :title="option.title"
                        @keyup.enter="enterPressed"
                    >
                    </SummerNote>
                </div>
                <div v-else>
                    <div class="show-option pt-20 pt-md-5">
                        <div class="option-text-container">
                            <p v-html="option.body.trim() === '' ? 'Option' : option.body.trim()"></p>
                        </div>
                    </div>
                    <small class="invalid-feedback d-block"
                           v-show="error.body">
                        {{ error.body }}
                    </small>
                </div>
            </div>
            <div class="col-1">
                <button class="btn btn-lg bg-transparent"
                        @click="hasEditPermission ? confirmQuestionOptionRemoval() : unableToAddOrDeleteMsg()"><i
                    class="fa-solid fa-xmark"></i></button>
            </div>
        </div>
    </div>

</template>
<script setup>
import SummerNote from "../../../components/SummerNote.vue";
import FormElementWithoutLabel from "../../../components/FormElementWithoutLabel.vue";
</script>
<script>

export default {
    props: {
        sectionIndex: {
            type: Number,
            required: true
        },
        questionIndex: {
            type: Number,
            required: true
        },
        index: {
            type: Number,
            required: true,
        },
        option: {
            type: Object,
            required: true,
        },
        error: {
            type: Object,
            required: false,
        },
        placeholder: {
            type: String,
            required: false
        },
        currentlyEditingItemType: {
            type: String,
            required: true,
        },
        currentlyEditingItemIndex: {
            type: Number,
            required: true
        },
        removeOption: {
            type: Function,
            required: true,
        },
        makeEditable: {
            type: Function,
            required: true
        },
        hasEditPermission: {
            type: Boolean,
            required: true,
        },
        unableToAddOrDeleteMsg: {
            type: Function,
            required: true
        },
        addMoreAction: {
            type: Function,
            required: true,
        },
    },
    computed: {
        compositeId: function () {
            return `${this.sectionIndex}_${this.questionIndex}_${this.index}`;
        }
    },
    methods: {
        onChange(text) {
            this.option.title = text
        },
        onChangeContent(text) {
            this.option.body = text
        },
        confirmQuestionOptionRemoval() {
            Swal.fire(
                {
                    title: "Delete Question Option?",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#f2353c",
                    confirmButtonText: "Yes, delete!",
                }
            ).then(result => {
                if (result.isConfirmed) {
                    if (this.currentlyEditingItemType === 'option' + this.compositeId && this.currentlyEditingItemIndex === this.index) {
                        this.makeEditable('', 0);
                    }
                    this.removeOption(this.index);
                }
            });
        },
        enterPressed(event) {
            if (!event.shiftKey) {
                this.addMoreAction()
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.$refs[`mcq_option_${this.compositeId}`].click()
        });
    },
}
</script>
<style scoped>
.show-option {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center; /* vertically center */
}

.option-text-container {
    width: 100%;
    height: 100%;
}

.show-option div:hover {
    border-bottom: 2px solid;
    display: flex;
    align-items: center;
}
</style>